import { Attributes, ModelBase, Rules, Validation } from '@singularsystems/neo-core';

export default class ExportLetterCommand extends ModelBase {

    constructor() {
        super();
        this.makeObservable();
    }

    public letterAuthorisationBatchId: number = 0;

    @Attributes.Nullable()
    public letterAuthorisationId: number | null = null;

    public reExport: boolean = false;

    @Rules.EmailAddress()
    public overrideEmailAddress: string | null = null;

    public overridePassword: string | null = null;

    // Client only properties / methods

    @Attributes.NoTracking()
    public emailAddress: string = "";

    @Attributes.NoTracking()
    public isLetterPasswordProtected: boolean = false;

    @Attributes.NoTracking()
    public letterPassword: string = "";

    @Attributes.NoTracking()
    public hasSent: boolean = false;

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.overrideEmailAddress) {
            return "New export letter command";
        } else {
            return this.overrideEmailAddress;
        }
    }
}